import { render, staticRenderFns } from "./MenuAi.vue?vue&type=template&id=020f7a58&scoped=true"
import script from "./MenuAi.vue?vue&type=script&lang=js"
export * from "./MenuAi.vue?vue&type=script&lang=js"
import style0 from "./MenuAi.vue?vue&type=style&index=0&id=020f7a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f7a58",
  null
  
)

export default component.exports